module.exports = __webpack_public_path__ + "static/img/item13.2a84140.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/item13.png
// module id = dG0D
// module chunks = 1